import { render } from "./z-top-menu.vue?vue&type=template&id=629cb8a9&scoped=true"
import script from "./z-top-menu.vue?vue&type=script&lang=js"
export * from "./z-top-menu.vue?vue&type=script&lang=js"

import "./z-top-menu.vue?vue&type=style&index=0&id=629cb8a9&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629cb8a9"]])

export default __exports__